module.exports = __webpack_public_path__ + "img/KE.b6edaf7b.png";